// src/definitions/types.ts
var Language = /* @__PURE__ */ ((Language2) => {
  Language2["ENCA"] = "en_CA";
  Language2["FRCA"] = "fr_CA";
  Language2["EN"] = "en";
  Language2["FR"] = "fr";
  return Language2;
})(Language || {});

export {
  Language
};
